import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IconsLibraryService } from '@ps/core-config';
import { ToastComponent } from '@ps/ui';

@Component({
  standalone: true,
  imports: [RouterOutlet, ToastComponent],
  providers: [IconsLibraryService],
  selector: 'ps-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly _iconsLibraryService = inject(IconsLibraryService);

  constructor() {
    this._iconsLibraryService.register();
  }
}
